import React from 'react';

import { createStyles, Theme, withStyles } from '@material-ui/core/styles';
import Tooltip from '@material-ui/core/Tooltip';
import { AttachFile  } from '@material-ui/icons';
import AddBoxRounded from '@material-ui/icons/AddBoxRounded';
import MaterialTable from 'material-table';
import EditIcon from '@material-ui/icons/Edit';
import { Badge, Paper } from '@material-ui/core'; 

import tableIcons from '../../utils/editTableIcons';

import Awb from '../../models/Awb';

import style from './awbInfo.module.css';
import commonStyles from '../common/common.module.css';
import User, { UserRoleId } from '../../models/User';

const iconFontSize = 20;

const styles = (theme: Theme) =>

  createStyles({
    materialIcon: {
      color: '#000',
      fontSize: iconFontSize,
      '&:hover': {
        cursor: 'pointer'
      }
    },
    specials: {
      display: 'flex',
      flexDirection: 'column',
    },
    gap4px: {
      gap: '4px',
    },
    flexSpcl: {
      flexWrap: 'nowrap'
    },
    addIcon: {
      color: 'var(--primaryblue)',
      fontSize: '20px' 
    },
    '@media (max-width: 991px)': {
      flexSpcl: {
        flexWrap: 'wrap'
      },
    }
  });

interface AwbInfoGeneralComponentProps {
  classes: any;
  user: User;
  awb: Array<Awb>;
  orderType?: string;
  hasManifestCharge?: boolean;
  handleOpenModal: (modalType: string) => void;
  openParts: (awb: Awb) => void;
};

const awbInfoGeneralComponent = (props: AwbInfoGeneralComponentProps) => {

  const { classes } = props;
  
  return ( 
    <div className={ `${ commonStyles.wrapper } ${ style.wrapper }` }>
      <h3 className={ `${ commonStyles.header }` } >General Information</h3>
      <div className={style.inputsWrapper} >

        <MaterialTable
        
          components={{Container: props => <Paper {...props} elevation={0} className={ commonStyles.paperTable }/>}}

          icons={ tableIcons }

          data={ props.awb }

          columns={[
            {
              title: 'Airwaybill', field: '', cellStyle: { width: '120px' },
              render: (rowData: Awb) => {

                return <span>{ rowData.code }-{ rowData.number } { rowData.returned ? <span className={ style.red }>Returned to driver</span> : null}</span>;
              }
            },
            { title: 'Origin', field: 'origin' },

            { title: 'Destination', field: 'destination' },

            { title: 'Pcs', field: 'pieces' },

            {
              title: 'Wgt', field: 'weight',
              render: (rowData: Awb) => {

                return `${rowData.weight}K`;
              }
            },
            {
              title: 'Status',
              render: (rowData: Awb) => {
                const isDeliveredOrRejected = rowData.status === 'SHIPMENT DELIVERED' || rowData.status === 'SHIPMENT PARTIALLY DELIVERED' ||
                  rowData.status === 'SHIPMENT REJECTED' || rowData.status === 'SHIPMENT PARTIALLY REJECTED';
                const hasGoOrPickupOrder = props.orderType === 'go' || props.orderType === 'po';

                if (isDeliveredOrRejected || hasGoOrPickupOrder) {
                  return (
                    <span>
                      <span>{rowData.status}</span>
                      <span className={ style.PoD } onClick={() => props.handleOpenModal('pod')}>PoD</span>
                    </span>
                  )
                }

                return (
                  <span>{rowData.status}</span>
                )
              }
            },
            { title: 'SPL', field: 'awb', cellStyle: { padding: 0, margin: 0, width: '15%' }, headerStyle: { padding: '10px 0 10px 0', width: '15%', height: '1%' },
            render: (rowData: Awb) => { 
    
              return<span className={`${ commonStyles.dFlex } ${ props.classes.flexSpcl } ${ props.classes.gap4px }`}>
              { rowData.special_form_data ? rowData.special_form_data.specials_form_data.map((special: any) => {
                if (special.value) {
                  return (
                    <span className={ props.classes.specials }>
                      <div style={{ backgroundColor: special.color, border: special.border ? `dashed 2px ${special.border}` : ''    }} className={`${ commonStyles.specials }`}><div className={ commonStyles.colorPrimary }>{special.name}</div>
                      </div>
                      <span className={ commonStyles.spTemp }>{special.temp ? special.temp : ''}</span>
                    </span>
                  )
                }

              }) : null }
              {  rowData.special_form_data && rowData.special_form_data.other.name.length ? 
              rowData.special_form_data.other.name.map(others =><div style={{ backgroundColor: '#ffffff', border: '1px solid var(--primaryblue)', color: 'var(--primaryblue)' }} className={`${commonStyles.specials}`}>{others}</div>)
             : null }
            </span>;
            }
            },
            {
              title: 'Action', headerStyle: { textAlign: 'center' },
              render: (rowData: Awb) => {

                return <span className={style.awbActionsList}>
                  <Tooltip title="Attach file">
                    <span>
                      <Badge className={ `${commonStyles.attachmentBadge}` } color="secondary" badgeContent={ rowData.attachments_count }>
                        <AttachFile className={ classes.materialIcon } onClick={() => props.handleOpenModal('attachments')} />
                      </Badge>
                    </span>
                  </Tooltip>
                  { props.orderType === 'do' && !props.hasManifestCharge && <Tooltip title="Add Certified Manifest Charge">
                    <AddBoxRounded
                      className={ `${classes.materialIcon} ${classes.addIcon}` }
                      onClick={ () => props.handleOpenModal('addManifestCharge') }
                    />
                  </Tooltip> }
                  {(props.user.roleId === UserRoleId.GHA_SUPERVISOR || props.user.roleId === UserRoleId.GHA_MANAGER) && <Tooltip title="Edit Awb">
                      <EditIcon fontSize="small" onClick={ () => props.openParts(rowData) } />
                  </Tooltip>}

                </span>;
              }
            }
          ]}

          options={{
            search: false,
            paging: false,
            showTitle: false,
            actionsColumnIndex: -1,
            toolbar: false,
            sorting: false,
            headerStyle: {
              backgroundColor: 'var(--tbl_head_bkg)',
              color: 'var(--tbl_head_color)',
              zIndex: 2,
            },
          }}
        />
        
      </div>

    </div>
  );
};

export default withStyles(styles)(awbInfoGeneralComponent);